/* eslint-disable max-len */
var cdnSrc = function cdnSrc(src) {
  return "https://cdn.ov.app/media/gift-guide-22/".concat(src);
};

var hero = {
  image: {
    alt: 'A close-up shot of Outdoor Voices SoftShield jackets.',
    height: 400,
    width: 1420,
    src: cdnSrc('Hero-Desktop.jpg')
  },
  imageMobile: {
    alt: 'A close-up shot of Outdoor Voices SoftShield jackets.',
    height: 1000,
    width: 1000,
    src: cdnSrc('Hero-Mobile.jpg')
  },
  title: 'The OV Gift Guide',
  copy: 'Gifting OV? Always a good move.',
  cta: 'Shop &mdash; Our Top Gifts',
  url: '/collections/bestsellers'
};
var giftsForHer = {
  cta: 'Shop &mdash; Women',
  image: {
    alt: 'A smiling woman wearing the PrimoFleece 1/4 Zip Hoodie in Frosty Fairweather.',
    src: cdnSrc('Her.jpg'),
    height: 4000,
    width: 3000
  },
  images: [{
    alt: '3 women joining arms wearing the Outdoor Voices Seamless line.',
    height: 1000,
    width: 1000,
    src: cdnSrc('Her1.jpg')
  }, {
    alt: 'An animated gif of 4 Snow Peak Titanium Aurora Bottles.',
    height: 1000,
    width: 1000,
    src: cdnSrc('Her2.gif')
  }, {
    alt: 'A clothes rack of products from the CloudKnit collection.',
    big: true,
    height: 2217,
    width: 1348,
    src: cdnSrc('Her3.jpg')
  }, {
    alt: 'A pile of pink Outdoor Voices products.',
    height: 1150,
    width: 1000,
    src: cdnSrc('Her4.jpg')
  }, {
    alt: 'A smiling woman wearing the PrimoFleece 1/4 Zip Hoodie in Frosty Fairweather.',
    height: 1150,
    width: 1000,
    src: cdnSrc('Her5.jpg')
  }, {
    alt: 'A flat layout of blue products.',
    height: 1000,
    width: 1000,
    src: cdnSrc('Her6.jpg')
  }, {
    alt: 'A stack of various clothing and accessories resting on a folding stool.',
    height: 1000,
    width: 1000,
    src: cdnSrc('Her7.jpg')
  }, {
    alt: 'A profile shot of three women wearing SoftShield jackets.',
    height: 1005,
    width: 1348,
    src: cdnSrc('Her8.jpg')
  }],
  title: 'Gifts for Her',
  url: '/collections/gifts-for-her'
};
var giftsForHim = {
  cta: 'Shop &mdash; Men',
  image: {
    alt: 'A seated man wearing a top and bottom from the CloudKnit collection in Mocha.',
    src: cdnSrc('Him.jpg'),
    height: 4000,
    width: 3000
  },
  images: [{
    alt: 'A flat layout of green Outdoor Voices products.',
    height: 1005,
    width: 1348,
    src: cdnSrc('Him1.jpg')
  }, {
    alt: 'A stack of Outdoor Voices products on a chair.',
    height: 1000,
    width: 1000,
    src: cdnSrc('Him2.jpg')
  }, {
    alt: 'A folded stack of orange and red products.',
    height: 1000,
    width: 1000,
    src: cdnSrc('Him3.jpg')
  }, {
    alt: 'A seated man wearing a top and bottom from the CloudKnit collection in Mocha.',
    big: true,
    height: 2216,
    width: 1348,
    src: cdnSrc('Him4.jpg')
  }, {
    alt: 'An animated gif of various pairs of Gloves.',
    height: 1150,
    width: 1000,
    src: cdnSrc('Him5.gif')
  }, {
    alt: 'A reclining man wearing a top and bottom from the CloudKnit collection in Charcoal.',
    height: 1200,
    width: 900,
    src: cdnSrc('Him6.jpg')
  }, {
    alt: 'The Doing Things Hat in blue and Outdoor Voices Hat in orange.',
    height: 1000,
    width: 1000,
    src: cdnSrc('Him7.jpg')
  }, {
    alt: 'A flat layout of various clothing and accessories.',
    height: 1000,
    width: 1000,
    src: cdnSrc('Him8.jpg')
  }],
  title: 'Gifts for Him',
  url: '/collections/gifts-for-him'
};
var blocks = [{
  image: {
    alt: 'Various stocking stuffers from Outdoor Voices.',
    src: cdnSrc('CategoriesStockingStuffer-3x4.jpg'),
    height: 2400,
    width: 1800
  },
  imageMobile: {
    alt: 'Various stocking stuffers from Outdoor Voices.',
    src: cdnSrc('CategoriesStockingStuffer-1x1.jpg'),
    height: 1000,
    width: 1000
  },
  title: 'Stocking Stuffers',
  url: '/collections/stocking-stuffers'
}, {
  image: {
    alt: 'An assortment of gifts under $50 from Outdoor Voices.',
    src: cdnSrc('CategoriesGiftsUnder50-3x4.jpg'),
    height: 2400,
    width: 1800
  },
  imageMobile: {
    alt: 'An assortment of gifts under $50 from Outdoor Voices.',
    src: cdnSrc('CategoriesGiftsUnder50-1x1.jpg'),
    height: 1000,
    width: 1000
  },
  title: 'Gifts Under $50',
  url: '/collections/gifts-under-50'
}, {
  image: {
    alt: 'An assortment of gifts by activity from Outdoor Voices.',
    src: cdnSrc('CategoriesGiftsByActivity-3x4.jpg'),
    height: 2400,
    width: 1800
  },
  imageMobile: {
    alt: 'An assortment of gifts by activity from Outdoor Voices.',
    src: cdnSrc('CategoriesGiftsByActivity-1x1.jpg'),
    height: 1000,
    width: 1000
  },
  title: 'Gifts by Activity',
  url: '/collections/gifts-by-activity'
}];
var giftCards = {
  title: 'A gift that fits all. <br>Ta-da.',
  cta: 'Shop &mdash; Gift Cards',
  imageCard: {
    alt: 'Outdoor Voices Gift Card',
    height: 426,
    width: 646,
    src: cdnSrc('gift-card.png')
  },
  imageCase: {
    height: 426,
    width: 646,
    alt: 'Outdoor Voices Gift Card Envelope',
    src: cdnSrc('envelope.png')
  },
  url: '/products/digital-gift-certificate'
};
var giftsMisc = {
  title: 'Tips for <em>Gifting Things</em>.',
  items: [{
    image: {
      alt: 'Blue Outdoor Voices gift boxes and OV totes.',
      src: cdnSrc('GG_-_Gift_Boxes_-_Desktop.jpg'),
      height: 900,
      width: 900
    },
    title: 'Let us do the wrapping.',
    copy: 'Add a gift box and a free gift note at checkout.',
    url: '/pages/gifting-services'
  }, {
    image: {
      alt: 'Two Outdoor Voices store associates holding OV totes.',
      src: cdnSrc('Gift-Advice.jpg'),
      height: 1000,
      width: 1000
    },
    title: 'Need gift advice?',
    copy: 'Talk to a store associate (AKA, a Recspert) for help wrapping up your list.',
    url: 'https://videochat.outdoorvoices.com/'
  }, {
    image: {
      alt: 'One of our Outdoor Voices shops.',
      src: cdnSrc('GG_-_Stores.jpg'),
      height: 900,
      width: 900
    },
    title: 'Get it ASAP.',
    copy: 'Buy online and pickup in-shop, or visit us in-store to see whatever you’ve been eyeing IRL.',
    url: 'https://www.outdoorvoices.com/pages/visit-us'
  }]
};
var questions = {
  title: 'Questions for us?',
  copy: 'Head to our <a href="/pages/help-center-holiday-questions">Help Center</a> for answers on fit, ship times, returns, and more.',
  image: {
    alt: 'Snowflakes',
    src: cdnSrc('FAQs_Desktop.jpg'),
    height: 228,
    width: 1420
  },
  imageMobile: {
    alt: 'Snowflakes',
    src: cdnSrc('FAQs-Mobile.jpg'),
    height: 270,
    width: 375
  }
};
var props = {
  hero: hero,
  giftsForHer: giftsForHer,
  giftsForHim: giftsForHim,
  blocks: blocks,
  giftCards: giftCards,
  giftsMisc: giftsMisc,
  questions: questions
};
export default props;